import * as fromAuthReducers from './reducers';
import * as fromAuthSelectors from './selectors';

/** Auth feature reducers and selectors, exposed as a single namespace. */
export const fromAuth = {
  ...fromAuthReducers,
  ...fromAuthSelectors
};
